module.exports = __webpack_public_path__ + "static/gribben_seo_primary_banner-02dfb3886b88cd36557c02ad08e339af.jpg";